// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/command.js';

import { paths } from '../generated/command';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('command', Original, paths);
